import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "en", setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return window.localStorage.getItem("lang") === "en" ? "en" : "el";
    } catch {
      return "el";
    }
  });

  const setLang = (l) => {
    setLangState(l);
    try {
      window.localStorage.setItem("lang", l);
    } catch {}
  };

  useEffect(() => {
    document.documentElement.lang = lang === "el" ? "el" : "en";
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
